(() => {
  function qs(sel, root=document){ return root.querySelector(sel); }
  function qsa(sel, root=document){ return Array.from(root.querySelectorAll(sel)); }
  function bubble(win, who, text){
    const b = document.createElement('div');
    b.className = `ai-bubble ${who==='Tú'?'ai-bubble--user':'ai-bubble--bot'}`;
    b.innerHTML = text.replace(/\n/g,'<br>');
    win.appendChild(b); win.scrollTop = win.scrollHeight;
  }
  function setLoader(id, show){ const el = qs(`#AILoader-${id}`); if(el) el.hidden = !show; }
  function whatsappLink(num, text){ const t = encodeURIComponent(text); return `https://wa.me/${num.replace(/[^+\d]/g,'')}?text=${t}`; }
  // autogrow textarea
  function autoGrow(ta){
    if(!ta) return; ta.style.height = 'auto'; ta.style.height = Math.min(ta.scrollHeight, 160) + 'px';
  }

  // Tema: persistencia y toggle
  const THEME_KEY = 'ai-chat-theme';
  function isDark(root){ return root.classList.contains('ai-dark'); }
  function setTheme(root, dark){
    if(dark) root.classList.add('ai-dark'); else root.classList.remove('ai-dark');
    const btn = root.querySelector('[data-ai-action="toggle-theme"]');
    if(btn) btn.textContent = 'Modo ' + (dark ? 'claro' : 'oscuro');
  }
  function applyStoredTheme(){
    // Forzar tema claro por solicitud: guardar y aplicar 'light'
    try { localStorage.setItem(THEME_KEY, 'light'); } catch(_) {}
    qsa('.ai-chat').forEach(root => { setTheme(root, false); });
  }
  applyStoredTheme();

  // ayuda modal
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-ai-help="open"]');
    const close = e.target.closest('[data-ai-help="close"]');
    const modal = qs('#AIModalHelp');
    if(open){ modal.style.display='flex'; modal.setAttribute('aria-hidden','false'); }
    if(close || e.target === modal){ modal.style.display='none'; modal.setAttribute('aria-hidden','true'); }
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-ai-action]');
    if(!btn) return;
    const action = btn.getAttribute('data-ai-action');
    const id = btn.getAttribute('data-target');
    const root = qs(`#AIConfigurator-${id}`);
    if(!root) return;
    if(action === 'toggle-theme'){
      const dark = !isDark(root);
      setTheme(root, dark);
      try{ localStorage.setItem(THEME_KEY, dark ? 'dark' : 'light'); }catch(_){ }
      return;
    }
    const apiBase = root.dataset.apiBase || '';
    const win = qs(`#AIChatWindow-${id}`);
    const txt = qs(`#AIMessage-${id}`);
    const err = qs(`#AIError-${id}`);
    const preview = qs(`#AIPreview-${id}`);
    const imgWrap = qs(`#AIPreviewImgWrap-${id}`);
    const to = root.dataset.whatsapp || '';
    err.hidden = true;

    const message = (txt.value || '').trim();

    // evitar colas: bloquear mientras hay loader
    const busy = !qs(`#AILoader-${id}`).hidden;
    if (busy && action !== 'whatsapp') return;

    try{
      // Modo según badges
      const modeWrap = root.querySelector('.ai-inputbar');
      const mode = (modeWrap?.dataset?.mode) || 'chat';
      const sendLabel = qs(`#AISendLabel-${id}`);
      if (sendLabel) sendLabel.textContent = mode === 'image' ? 'Generar imagen' : (mode === '3d' ? 'Generar 3D' : 'Enviar');

      if(action === 'send'){
        if(!message) return;
        bubble(win, 'Tú', message);
        txt.value = '';
        if(!apiBase){ bubble(win,'IA','(configura API Base en el editor del tema)'); return; }
        setLoader(id, true);
        if (mode === 'image') {
          const r = await fetch(`${apiBase}/api/2d`, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ prompt: message }) });
          const data = await r.json();
          setLoader(id, false);
          if(!data.url){ bubble(win,'IA',`Estado: ${data.status || 'en proceso'}`); return; }
          preview.hidden = false; imgWrap.innerHTML = `<img src="${data.url}" alt="preview" style="display:block;width:100%">`;
          bubble(win,'IA','Imagen lista.');
        } else if (mode === '3d') {
          const r = await fetch(`${apiBase}/api/3d`, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ prompt: message }) });
          const data = await r.json();
          setLoader(id, false);
          if(!(data.preview_url||data.model_url)){ bubble(win,'IA',`Estado: ${data.status || 'en proceso'}`); return; }
          preview.hidden = false; const url = data.preview_url || data.model_url;
          imgWrap.innerHTML = `<img src="${url}" alt="preview 3D" style="display:block;width:100%">`;
          bubble(win,'IA','3D listo.');
        } else {
          const r = await fetch(`${apiBase}/api/chat`, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ message }) });
          const data = await r.json();
          setLoader(id, false);
          bubble(win, 'IA', data.reply || '…');
        }
      }
      if(action === 'gen2d'){
        if(!apiBase){ bubble(win,'IA','(configura API Base)'); return; }
        const prompt = message || 'concepto joya minimalista con estrellas y diamantes';
        bubble(win,'IA','Generando imagen… <span class="ai-spinner"></span>');
        setLoader(id, true);
        const r = await fetch(`${apiBase}/api/2d`, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ prompt }) });
        const data = await r.json();
        setLoader(id, false);
        if(!data.url){ bubble(win,'IA',`Estado: ${data.status || 'en proceso'}`); return; }
        preview.hidden = false; imgWrap.innerHTML = `<img src="${data.url}" alt="preview" style="display:block;width:100%">`;
        bubble(win,'IA','Imagen lista.');
      }
      if(action === 'gen3d'){
        if(!apiBase){ bubble(win,'IA','(configura API Base)'); return; }
        const prompt = message || 'Jewelry, stars & diamonds, minimal, gold, photorealistic';
        bubble(win,'IA','Generando 3D… <span class="ai-spinner"></span>');
        setLoader(id, true);
        const r = await fetch(`${apiBase}/api/3d`, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ prompt }) });
        const data = await r.json();
        setLoader(id, false);
        if(!(data.preview_url||data.model_url)){ bubble(win,'IA',`Estado: ${data.status || 'en proceso'}`); return; }
        preview.hidden = false;
        const url = data.preview_url || data.model_url;
        imgWrap.innerHTML = `<img src="${url}" alt="preview 3D" style="display:block;width:100%">`;
        bubble(win,'IA','3D listo.');
      }
      if(action === 'whatsapp'){
        const content = win.textContent.trim();
        const link = whatsappLink(to, content);
        window.open(link, '_blank');
      }
    }catch(ex){
      setLoader(id, false);
      err.hidden = false; err.textContent = ex.message || 'Error';
    }
  });

  // cambiar modo por badges
  document.addEventListener('click', (e) => {
    const tgl = e.target.closest('[data-ai-config="toggle"]');
    if (tgl) {
      const bar = document.querySelector('.ai-inputbar');
      const mask = document.getElementById('AIConfigMask-' + (bar?.id?.split('AIConfigurator-')[1] || '')) || document.querySelector('[id^="AIConfigMask-"]');
      const sheet = document.getElementById('AIConfigSheet-' + (bar?.id?.split('AIConfigurator-')[1] || '')) || document.querySelector('[id^="AIConfigSheet-"]');
      const open = bar?.dataset?.open === 'true';
      if (bar) { bar.dataset.open = open ? 'false' : 'true'; tgl.setAttribute('aria-expanded', (!open).toString()); }
      if (mask && sheet) {
        const willOpen = !open;
        mask.hidden = !willOpen; sheet.hidden = !willOpen;
        if (willOpen) { mask.classList.add('open'); sheet.classList.add('open'); }
        else { mask.classList.remove('open'); sheet.classList.remove('open'); }
      }
      return;
    }
    const modeBtn = e.target.closest('[data-ai-mode]');
    if(!modeBtn) return;
    const wrap = modeBtn.closest('.ai-inputbar');
    if(!wrap) return;
    const mode = modeBtn.getAttribute('data-ai-mode');
    wrap.dataset.mode = mode;
    // activar visual
    wrap.querySelectorAll('[data-ai-mode]').forEach(b => { b.classList.toggle('ai-badge--on', b === modeBtn); b.setAttribute('aria-pressed', b === modeBtn ? 'true' : 'false'); });
    const sendLabel = wrap.querySelector('[id^="AISendLabel-"]');
    if (sendLabel) sendLabel.textContent = mode === 'image' ? 'Generar imagen' : (mode === '3d' ? 'Generar 3D' : 'Enviar');
  });

  // autogrow y Enter para enviar
  document.addEventListener('input', (e) => {
    const ta = e.target.closest('textarea[id^="AIMessage-"]');
    if(!ta) return; autoGrow(ta);
  });
  document.addEventListener('keydown', (e) => {
    const ta = e.target.closest('textarea[id^="AIMessage-"]');
    if(!ta) return;
    if(e.key === 'Enter' && !e.shiftKey){
      e.preventDefault();
      const id = ta.id.split('AIMessage-')[1];
      const btn = document.querySelector(`[data-ai-action="send"][data-target="${id}"]`);
      if(btn) btn.click();
    }
  });

  // chips
  document.addEventListener('click', (e) => {
    const chip = e.target.closest('.ai-chip');
    if(!chip) return;
    const wrap = chip.closest('.ai-chat');
    const id = wrap.id.split('AIConfigurator-')[1];
    const txt = qs(`#AIMessage-${id}`);
    const p = chip.getAttribute('data-prompt') || '';
    txt.value = p;
  });
})();


